import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { ReuniaoComMesAno } from '../../../../../services/requests';

import { CardMeeting, Div, Status } from './styles';
import { getTypeStatus } from '../../../../../utils/meetingHelpers';

dayjs().format();

interface MeetingCardProps {
  meeting: ReuniaoComMesAno;
}

export const MeetingCard = ({ meeting }: MeetingCardProps) => {
  return (
    <CardMeeting
      key={meeting?.id}
      status={meeting?.canceled_at}
      sx={{
        background: meeting?.canceled_at ? '#FFD9DA' : '#ffffff',
      }}
    >
      <Div>
        <div className="date-meeting">
          <span className="month-meeting">
            {dayjs(meeting?.start_at || new Date()).format('DD/MM/YY')}
          </span>
          <Box display="flex">
            <Typography
              className="duration-meeting"
              sx={{ color: meeting?.canceled_at ? '#D01317' : '#12094d' }}
            >
              {meeting?.horaInicial.includes('AM')
                ? meeting.horaInicial.split('AM')
                : meeting.horaInicial.split('PM')}{' '}
              -{' '}
              {meeting.horaFinal.includes('AM')
                ? meeting.horaFinal.split('AM')
                : meeting.horaFinal.split('PM')}
            </Typography>
          </Box>
        </div>
        <Box display="flex" flexDirection="column" gap="10px">
          <Status
            sx={{
              background: getTypeStatus(meeting?.status)?.color,
            }}
          >
            {getTypeStatus(meeting?.status)?.status}
          </Status>
          <Typography className="title">{meeting?.title}</Typography>
        </Box>
      </Div>
    </CardMeeting>
  );
};
